var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRdlawLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 67,
    viewBox: "0 0 200 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.625 0.38932H143.225V31.9893H137.625V0.38932Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.425 9.98932H136.025V31.9893H130.425V9.98932Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.225 17.856H128.825V31.9893H123.225V17.856Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -21,
    y: -28,
    width: 426,
    height: 95
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.92 -27.4533H404.732V66.2493H-20.92V-27.4533Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02537 19.9887H12.692C15.092 19.9887 16.292 18.7888 16.292 17.0554C16.292 15.3221 15.2254 13.9887 12.8254 13.9887H8.02537V19.9887ZM3.62537 10.5221H13.492C17.6254 10.5221 20.4254 12.9221 20.4254 16.5221C20.4254 19.0554 19.2254 20.9221 16.4254 21.7221C18.4254 22.2554 19.492 23.4554 19.7587 26.1221C20.0254 29.1887 19.892 31.4554 20.692 31.8554V32.1221H16.5587C16.0254 31.8554 15.892 29.4554 15.7587 27.1887C15.6254 24.7887 14.292 23.4554 11.492 23.4554H8.02537V32.1221H3.62537V10.5221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6255 24.2554C33.6255 21.1887 32.1588 19.1887 29.7588 19.1887C27.2255 19.1887 25.8922 21.1887 25.8922 24.2554C25.8922 27.3221 27.2255 29.3221 29.7588 29.3221C32.2922 29.3221 33.6255 27.3221 33.6255 24.2554ZM21.6255 24.2554C21.6255 19.5887 24.9588 16.1221 29.7588 16.1221C34.5588 16.1221 37.8922 19.7221 37.8922 24.2554C37.8922 28.7887 34.5588 32.3887 29.7588 32.3887C24.9588 32.3887 21.6255 28.9221 21.6255 24.2554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6921 27.0554H42.4255C42.6921 28.7888 44.0255 29.5888 45.7588 29.5888C47.6255 29.5888 48.5588 28.9221 48.5588 27.8554C48.5588 26.3888 46.5588 26.2554 44.5588 25.8554C41.7588 25.3221 39.0921 24.5221 39.0921 21.1888C39.0921 17.8554 41.8921 16.2554 45.3588 16.2554C49.3588 16.2554 51.6255 18.2554 52.0255 21.3221H48.2921C48.1588 19.7221 47.0921 19.0554 45.3588 19.0554C43.7588 19.0554 42.6921 19.7221 42.6921 20.7888C42.6921 22.1221 44.6921 22.2554 46.9588 22.6554C49.4921 23.1888 52.4255 23.8554 52.4255 27.5887C52.4255 30.6554 49.7588 32.5221 45.8921 32.5221C41.4921 32.5221 38.9588 30.2554 38.6921 27.0554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4253 18.5223C59.6253 16.9223 60.9587 16.1223 62.9587 16.1223C66.1587 16.1223 68.292 18.5223 68.292 21.8556V31.9889H64.1587V22.5223C64.1587 20.9223 63.2253 19.7222 61.492 19.7222C59.6253 19.7222 58.4253 21.1889 58.4253 23.3223V32.1223H54.292V10.5223H58.4253V18.5223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0251 24.2554C82.0251 21.1887 80.5585 19.1887 78.1585 19.1887C75.6251 19.1887 74.2918 21.1887 74.2918 24.2554C74.2918 27.3221 75.6251 29.3221 78.1585 29.3221C80.6918 29.3221 82.0251 27.3221 82.0251 24.2554ZM70.0251 24.2554C70.0251 19.5887 73.3585 16.1221 78.1585 16.1221C82.9585 16.1221 86.2918 19.7221 86.2918 24.2554C86.2918 28.7887 82.9585 32.3887 78.1585 32.3887C73.3585 32.5221 70.0251 28.9221 70.0251 24.2554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1584 10.5225H92.2918V31.9892H88.1584V10.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9588 16.5221H98.9588V18.6554H99.0921C99.8921 17.1888 101.492 16.1221 103.625 16.1221C105.625 16.1221 107.092 17.1888 107.892 18.7888C108.959 17.0554 110.559 16.1221 112.559 16.1221C115.759 16.1221 117.625 18.2554 117.625 21.5888V31.9888H113.492V22.2554C113.492 20.5221 112.559 19.5888 111.092 19.5888C109.359 19.5888 108.292 20.9221 108.292 22.9221V31.9888H104.159V22.1221C104.159 20.3888 103.225 19.4554 101.759 19.4554C100.159 19.4554 98.9588 20.7888 98.9588 22.7888V31.9888H94.8254L94.9588 16.5221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.559 28.2553C160.692 28.2553 162.292 25.722 162.292 21.4553C162.292 17.1886 160.425 14.2553 156.692 14.2553H153.225V28.2553H156.559ZM148.825 10.522H157.225C162.959 10.522 166.692 15.1886 166.692 21.4553C166.692 24.922 165.492 27.9887 163.225 29.8553C161.625 31.1886 159.492 31.9886 156.825 31.9886H148.825V10.522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.025 22.6553H178.825C178.692 20.6553 177.358 19.322 175.492 19.322C173.492 19.322 172.425 20.6553 172.025 22.6553ZM168.025 24.2553C168.025 19.722 171.092 16.122 175.625 16.122C180.558 16.122 183.225 19.8553 183.225 25.4553H172.025C172.292 27.8553 173.625 29.322 176.025 29.322C177.625 29.322 178.558 28.6553 178.958 27.4553H182.958C182.425 30.2553 179.892 32.522 176.025 32.522C170.825 32.522 168.025 28.922 168.025 24.2553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.225 10.5225H189.358V31.9892H185.225V10.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.025 10.5225H196.158V31.9892H192.025V10.5225Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8904 51.1768H29.5972L27.6652 44.957C27.3027 43.8085 26.7897 41.6353 26.7897 41.6353H26.7284C26.7284 41.6353 26.1861 43.8085 25.8224 44.957L23.8904 51.1768ZM24.5246 37.5288H29.0535L36.6616 59.1166H32.1021L30.6537 54.5278H22.8631L21.4455 59.1166H17.0072L24.5246 37.5288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9534 51.4788C47.9534 48.5195 46.9874 46.5263 44.3613 46.5263C42.0961 46.5263 40.9489 48.5195 40.9489 51.3882C40.9489 54.3768 42.1267 56.1276 44.2399 56.1276C46.6863 56.1276 47.9534 54.3168 47.9534 51.4788ZM36.7825 51.3882C36.7825 46.5581 39.5311 43.2059 43.3951 43.2059C45.5683 43.2059 46.9261 44.2012 47.7722 45.5003H47.8641V37.5297H51.9693V59.1163H48.0147V57.0936H47.9534C47.0474 58.5725 45.5085 59.5692 43.3339 59.5692C39.4393 59.5692 36.7825 56.3995 36.7825 51.3882Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3569 43.628H57.5233L59.9991 51.6598C60.452 53.1388 60.6945 54.1341 60.6945 54.1341H60.7545C60.7545 54.1341 60.9651 53.1388 61.418 51.6598L63.9536 43.628H68.0601L62.6559 59.1173H58.7305L53.3569 43.628Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2578 51.3876C80.2578 48.3684 78.8387 46.3151 76.3338 46.3151C73.7955 46.3151 72.4071 48.3684 72.4071 51.3876C72.4071 54.4068 73.7955 56.4295 76.3338 56.4295C78.8387 56.4295 80.2578 54.4068 80.2578 51.3876ZM68.2407 51.3876C68.2407 46.7681 71.5318 43.2052 76.3338 43.2052C81.1332 43.2052 84.4242 46.7681 84.4242 51.3876C84.4242 56.0071 81.1332 59.57 76.3338 59.57C71.5318 59.57 68.2407 56.0071 68.2407 51.3876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1833 52.0513L90.4018 53.894V59.1172H86.3259V37.5293H90.4018V49.4851L95.8967 43.6277H100.817L95.1119 49.5157L101.513 59.1172H96.531L92.1833 52.0513Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.657 53.6516V51.3279C110.932 51.7489 109.814 51.9915 108.788 52.2339C106.644 52.7162 105.587 53.1986 105.587 54.6482C105.587 56.0979 106.553 56.6109 108.003 56.6109C110.358 56.6109 111.657 55.1612 111.657 53.6516ZM111.626 57.3957H111.566C110.781 58.5723 109.663 59.4783 107.007 59.4783C103.837 59.4783 101.602 57.818 101.602 54.7389C101.602 51.3279 104.38 50.2393 107.822 49.7569C110.388 49.3959 111.566 49.1827 111.566 48.0061C111.566 46.8896 110.689 46.1648 108.968 46.1648C107.036 46.1648 106.101 46.8589 105.979 48.3379H102.327C102.448 45.6211 104.47 43.2348 109 43.2348C113.649 43.2348 115.521 45.3187 115.521 48.9428V56.8228C115.521 57.9993 115.702 58.6935 116.064 58.9653V59.1172H112.11C111.867 58.8147 111.717 58.0899 111.626 57.3957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.91 43.628H119.052V38.798H123.068V43.628H125.725V46.3461H123.068V54.5579C123.068 55.7051 123.704 56.0981 124.608 56.0981C125.121 56.0981 125.817 56.0661 125.817 56.0661V59.0867C125.817 59.0867 124.879 59.1467 123.251 59.1467C121.257 59.1467 119.052 58.3619 119.052 55.4332V46.3461H116.91V43.628Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.858 51.3876C138.858 48.5203 137.711 46.5269 135.416 46.5269C132.82 46.5269 131.854 48.6095 131.854 51.4782C131.854 54.3163 133.273 56.1284 135.567 56.1284C137.68 56.1284 138.858 54.3763 138.858 51.3876ZM131.854 57.1849H131.794V59.1169H127.838V37.5291H131.946V45.4996H132.035C132.881 44.2005 134.209 43.2052 136.352 43.2052C140.246 43.2052 143.024 46.5576 143.024 51.3876C143.024 56.4001 140.368 59.57 136.473 59.57C134.299 59.57 132.76 58.6333 131.854 57.1849Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.806 60.9578H146.256C147.887 60.9578 148.55 60.1131 148.55 58.8446C148.55 57.9985 148.248 57.0032 147.372 54.6489L143.206 43.6284H147.523L149.819 50.6036C150.301 52.0213 150.815 53.984 150.815 53.984H150.875C150.875 53.984 151.298 52.0213 151.78 50.6036L153.954 43.6284H158.092L152.686 59.5094C151.508 62.9512 150.362 64.1889 147.22 64.1889H144.806V60.9578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.434 46.1035H163.523C164.46 44.3527 165.516 43.4467 167.328 43.4467C167.782 43.4467 168.053 43.4773 168.293 43.5679V47.1614H168.204C165.516 46.8896 163.584 48.3073 163.584 51.5691V59.1172H159.478V43.6279H163.434V46.1035Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_16_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -1,
    width: 426,
    height: 95
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-215.445 -0.31882H209.915V93.3196H-215.445V-0.31882Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.654 39.3405C177.654 38.5557 177.08 37.9214 176.295 37.9214C175.512 37.9214 174.938 38.5557 174.938 39.3405C174.938 40.1253 175.512 40.7596 176.295 40.7596C177.08 40.7596 177.654 40.1253 177.654 39.3405ZM173.367 39.3405C173.367 37.7709 174.695 36.5025 176.295 36.5025C177.897 36.5025 179.225 37.7709 179.225 39.3405C179.225 40.9408 177.897 42.1785 176.295 42.1785C174.695 42.1785 173.367 40.9408 173.367 39.3405ZM178.923 53.652V51.3282C178.198 51.7493 177.08 51.9918 176.054 52.233C173.91 52.7166 172.854 53.199 172.854 54.6486C172.854 56.0984 173.82 56.61 175.269 56.61C177.625 56.61 178.923 55.1616 178.923 53.652ZM178.892 57.3948H178.832C178.047 58.5726 176.93 59.4786 174.273 59.4786C171.103 59.4786 168.868 57.8185 168.868 54.7393C168.868 51.3282 171.647 50.2397 175.088 49.7573C177.654 49.3949 178.832 49.183 178.832 48.0052C178.832 46.89 177.957 46.1652 176.235 46.1652C174.302 46.1652 173.367 46.8593 173.245 48.337H169.593C169.715 45.6202 171.737 43.2352 176.266 43.2352C180.915 43.2352 182.788 45.319 182.788 48.9433V56.8232C182.788 57.9984 182.968 58.6938 183.331 58.9657V59.1162H179.376C179.133 58.8152 178.983 58.0902 178.892 57.3948Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.479,
    height: 66.2493,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdlawLogoWhite);
export default __webpack_public_path__ + "static/media/rdlaw-logo-white.9de37a268d2c7f394dba318c59dca446.svg";
export { ForwardRef as ReactComponent };